import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { User } from "./apiEcms.types";

const getUsers = (signal: AbortSignal) =>
  apiEcmsHttp.get<{
    users: User[];
  }>("/users", { signal });

export const useGetUsers = (enabled?: boolean) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.USERS, currentGroup],
    queryFn: ({ signal }) => getUsers(signal),
    select: ({ data }) => data.users,
    enabled,
  });
};
